import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { post,uploadTemplate } from "../../../services/api";
import {Spinner } from "react-bootstrap";

const AddTemplates = forwardRef((props, ref) => {

  const [filename,setfilename]= useState();
  const [isLoading, setIsloading] = useState(false);

  const [file,setfile]= useState();
  const [addLov, setAddLov] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    value:"",
    type:"",
    attribute1:"",
    attribute2:"",
    attribute3:"",
    attribute4:""
                   
  });
  
  const onSubmit = async (e)=>{
    setIsloading(true);
    e.preventDefault();
    const response = await uploadTemplate(file,props.token);
    const body = {
      fileName: filename ? filename : file?.name,
      fileLink: response?.url,
    }
    await post('/api/template',body, props.token);
    setfilename();
    setfile();
    setIsloading(false);
    toast.success("Template saved saved successfully");
  }


  
  const resetForm = () => {
    setFormData({
      value:"",
      type:"",
      attribute1:"",
      attribute2:"",
      attribute3:"",
      attribute4:""
    });
  };

  const [errors, setErrors] = useState({});
  useImperativeHandle(ref, () => ({
    showAddLovModal() {
      setAddLov(true);
    },
  }));

  
  


  return (
    <Offcanvas
      show={addLov}
      onHide={() => setAddLov(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            resetForm();
            setAddLov(false);
          }}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
          <div className="row">
          
                    <div className="col-xl-12 mb-6 m-2">
                      
                      <label className="form-label">
                            File Name
                          </label>
                          <input
                            value={filename}
                            type="text"
                            className="form-control"
                            onChange={(e)=> { setfilename(e.target.value)}}
                          />
                    </div>
                    <div className="col-xl-12 mb-6 m-2">
                          <label className="form-label">
                            Select Document Template File (*.dotx)
                          </label>
                          <input className="form-control" type="file" accept=".dotx" onChange={(e)=> { setfile(e.target.files[0])}}/>
                         
                                                    
                        </div>
                      
                        <div className="col-xl-6 mt-4">
                        <button className="btn btn-primary me-1" onClick={onSubmit} >
                           {isLoading ? <Spinner size="sm"/> : 'Upload'}
                        </button>              
                        </div>
                        <div className="col-xl-6 mt-4">
                        <button
                          onClick={() => {
                            setAddLov(false)
                          }}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>   
                        </div>     
                        
                  
          </div>
  
      </div>
    </Offcanvas>
  );
});

export default AddTemplates;
